export const ICON_ID = {
	FILE: 'file',
	LINE_BOLD_FILE: 'line-bold-file',
	BTN_FILE: 'btn-file',
	MSG_FILE: 'msg-file',
	EXPIRED_FILE: 'expired-file',
} as const;
